import React from 'react';
import { Divider, Collapse, Row, Timeline, TimelineItemProps } from 'antd';
import { connect } from 'react-redux';
import { FcClock } from 'react-icons/fc';
import moment from 'moment';

import { Card } from 'src/components';
import { IReduxState } from 'src/store';

import { IProps } from './history.type';
import { Title } from './history.style';

const HistoryComponent: React.FC<IProps> = (props) => {
  const { task } = props;

  const items: TimelineItemProps | any = task?.historyAudits?.map(
    (item: any) => ({
      children: <small>{item?.message}</small>,
      label: (
        <small>
          <b>{moment(item?.createdAt).format('DD/MM/YY HH:mm')}</b>
        </small>
      ),
    })
  );

  return (
    <Card>
      <Title>
        <FcClock size={20} className="me-2" />
        <h4 className="m-0">Histórico</h4>
      </Title>
      <Divider className="mt-2 mb-3" />
      <Row gutter={8}>
        <small>
          Cadastrada em:
          <b> {moment(task?.createdAt).format('DD/MM/YY')} </b>
          às
          <b> {moment(task?.createdAt).format('HH:mm')}</b>
        </small>
        {task?.stage === 2 && (
          <small>
            Finalizada em:
            <b> {moment(task?.finishedAt).format('DD/MM/YY')} </b>
            às
            <b> {moment(task?.finishedAt).format('HH:mm')}</b>
          </small>
        )}

        {!!task?.historyAudits?.length && (
          <Collapse
            className="mt-2 mb-0"
            size="small"
            bordered={false}
            style={{ width: '100%' }}
            items={[
              {
                key: '1',
                label: <small>Detalhes</small>,
                children: (
                  <Timeline className="mt-4 mb-0" mode="left" items={items} />
                ),
              },
            ]}
          />
        )}
      </Row>
    </Card>
  );
};

const mapStateToProps = (state: IReduxState) => ({
  task: state.tasks.current,
});

export default connect(mapStateToProps, {})(HistoryComponent);
